import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { SITE } from "@/data/site";

export function QuickQuote({ vehicle }) {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const fmt = (d) => d ? new Date(d).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" }) : "";
  const days = from && to ? Math.max(0, Math.round((new Date(to) - new Date(from)) / 86400000)) : 0;
  const msg = `Hi Top End Wheels, I'd like a quote for the ${vehicle.name}` +
    (from && to ? ` from ${fmt(from)} to ${fmt(to)} (${days} day${days === 1 ? "" : "s"})` : "") + ". Is it available?";
  const href = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(msg)}`;

  return (
    <div className="mt-6 border-t border-black/10 pt-5" data-testid="quick-quote">
      <div className="overline text-[#595959]">WhatsApp quick quote</div>
      <div className="grid grid-cols-2 gap-2 mt-2">
        <label className="block"><span className="text-[0.65rem] uppercase tracking-wider text-[#595959]">Pickup</span>
          <input type="date" value={from} onChange={e => setFrom(e.target.value)} className="input text-sm" data-testid="qq-from"/></label>
        <label className="block"><span className="text-[0.65rem] uppercase tracking-wider text-[#595959]">Return</span>
          <input type="date" value={to} min={from || undefined} onChange={e => setTo(e.target.value)} className="input text-sm" data-testid="qq-to"/></label>
      </div>
      <a href={href} target="_blank" rel="noreferrer" className="btn-ghost w-full justify-center !mt-3 block text-center !bg-[#25D366] !text-white !border-[#25D366] hover:!bg-[#1ebe5b]" data-testid="qq-whatsapp">
        <MessageCircle className="w-4 h-4"/> {days > 0 ? `Quote ${days} day${days === 1 ? "" : "s"} on WhatsApp` : "Ask on WhatsApp"}
      </a>
    </div>
  );
}
